require('es6-promise').polyfill();
require('isomorphic-fetch');
import * as _ from 'lodash';

import {LoadingService} from './loading.service';
import {NotificationService} from './notification.service';
import environment from '../environments/environment';

export class ApiService {

  constructor() {
    this.loadingService = new LoadingService();
    this.notificationService = new NotificationService();
  }

  go(url, config = {}) {
    // Append the api endpoint
    url = _.trimEnd(config.apiUrl ? config.apiUrl : environment.apiUrl, '/') + '/' + _.trimStart(url, '/');

    // Configure the options
    config = this.prepare(config);

    this.loadingService.show();
    return new Promise((resolve, reject) => {
      fetch(url, config)
        .then(
          async (resp) => {
            if (!(resp.status >= 200 && resp.status < 300)) {
              throw resp;
            }

            this.loadingService.hide();

            resp.parsed = {
              status: resp.status,
              data  : resp.status >= 200 && resp.status < 300 ? await resp.json() : {}
            };
            resolve(resp);

            // Implementation without async/await
            // if (resp.status == 200) {
            //   resp.json()
            //     .then((respJson) => {
            //       resp.parsed = {
            //         status: resp.status,
            //         data  : respJson
            //       };
            //       resolve(resp);
            //     });
            // }
            // else {
            //   resp.parsed = {
            //     status: resp.status,
            //     data  : {}
            //   };
            //   resolve(resp);
            // }
          },
        )
        .catch((resp) => {
          this.loadingService.hide();
          let genericError = 'An error occurred. Our tech team has been alerted and will get to work on this issue shortly.';
          if (resp.status == 500) {
            // Removed notification on ticket [NEXT-40]
            // this.notificationService.error(genericError);
            reject(resp);
          }
          else if (resp.status === 401) {
            this.notificationService.error(_.startCase(_.toLower(resp.json().error.message)));
            console.error('Should redirect to login');
            reject(resp);
          }
          else if (resp.status === 404) {
            // let the component do whatever they need when there's a 404
            reject(resp);
          }
          else {
            // Removed notification on ticket [NEXT-40]
            // this.notificationService.error(genericError);
            reject(resp);
          }
        });
    });
  }

  prepare(config) {
    let configDefaults = {
      method: 'Get',
    };
    return Object.assign({}, configDefaults, config);
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

}


// WEBPACK FOOTER //
// ./services/api.service.js